import React, { FC } from 'react';

import styles from './PaperPlaneIcon.module.scss';

const PaperPlaneIcon: FC = () => {
  return (
    <svg width="59"
         height="58"
         viewBox="0 0 59 58"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M14.3098 55.2377C14.0307 55.2377 19.897 31.3504 19.897 31.3504C20.0399 30.8892 20.4148 30.5358 20.8841 30.4212C21.3521 30.3025 21.8497 30.4441 22.1909 30.7853L31.8575 40.4519C32.1407 40.7351 32.2864 41.1262 32.2581 41.5268C32.2297 41.9259 32.0301 42.2927 31.7092 42.5328L15.1379 54.9613C14.8938 55.146 14.6011 55.2377 14.3098 55.2377Z"
            className={styles.inside} />
      <path d="M46.0604 57.9994C45.7664 57.9994 45.4738 57.905 45.2324 57.7229L1.05294 24.5803C0.652413 24.2809 0.446087 23.79 0.512165 23.2951C0.576904 22.8002 0.904602 22.3794 1.36852 22.1933L56.6063 0.0982163C57.0769 -0.0878935 57.6137 -0.00697009 58.002 0.319388C58.3918 0.643054 58.5725 1.15416 58.4727 1.65178L47.4144 56.8895C47.3213 57.3548 46.9963 57.7391 46.5526 57.9091C46.3935 57.9697 46.2263 57.9994 46.0604 57.9994Z"
            className={styles.wings} />
      <path d="M14.3109 55.2379C14.2367 55.2379 14.1625 55.2325 14.0884 55.2203C13.4195 55.1111 12.9286 54.5339 12.9286 53.8569V33.1428C12.9286 32.7058 13.1363 32.2945 13.4869 32.0343L56.2962 0.272545C56.8828 -0.163046 57.7027 -0.0659516 58.1734 0.488318C58.6441 1.04528 58.6009 1.87061 58.0763 2.37633L20.1075 38.875L15.619 54.2939C15.4289 54.8643 14.8962 55.2379 14.3109 55.2379Z"
            className={styles.outside} />
    </svg>
  );
};

export default PaperPlaneIcon;
